import React from 'react';
import renderHTML from 'react-render-html';
import { EventCard } from './cards';
import RequestCallback from './request-callback';
import Article from './article';
import VideoModal from './video-modal';
import { MEDIA_TYPE_IS_ARTICLE, MEDIA_TYPE_IS_VIDEO } from '../../../app-constants';

export const HighlightsArticle = (props) => {
  if (props.mediaType === MEDIA_TYPE_IS_ARTICLE) {
    return <Article {...props} />;
  }
  if (props.mediaType === MEDIA_TYPE_IS_VIDEO) {
    return <VideoModal {...props} />;
  }
  return null;
};

export const ConversationArticle = (props) => {
  const { articleHasAeContent } = props;
  return articleHasAeContent ? <RequestCallback {...props} /> : <Article {...props} />;
};

export const CarouselItem = ({ wrapInCard = true, cardClass, ...props }) => (
  wrapInCard
    ? <EventCard cardClass={cardClass}>
      <Article {...props} />
    </EventCard>
    : <Article {...props} />
);

export const WideCarouselItem = (props) => {
  const { title, summary, url, buttonText, imageUrl, imageAltText, cardClass } = props;
  const leftPanel = {
    imageUrl,
    imageAltText,
  };
  const rightPanel = {
    title,
    summary,
    url,
    buttonText,
  };
  return (
    <EventCard cardClass={`d-block ${cardClass || ''}`}>
      <div className="row justify-content-around">
        <div className="col-sm-5 mb-2 mb-sm-0">
          <Article {...leftPanel} />
        </div>
        <div className="col-sm-4">
          <Article {...rightPanel} />
        </div>
      </div>
    </EventCard>
  );
};

export const EventHeaderDescription = (props) => {
  const isWrappedInPTag = props.description.indexOf('<p>') === 0;
  return (
    <div className="event-row__Description text-center">
      {isWrappedInPTag ? renderHTML(props.description) : <p>{renderHTML(props.description)}</p>}
    </div>
  );
};
